// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreatePatientGeneralBenefitsRequest } from './create-patient-general-benefits-request';

// @ts-ignore
import { CreatePatientInsuranceBasicInformationRequest } from './create-patient-insurance-basic-information-request';

// @ts-ignore
import { CreatePatientMaterialBenefitsRequest } from './create-patient-material-benefits-request';

/** See com.rev360.pms.api.controller.insurance.CreatePersonInsuranceRequest */
/* istanbul ignore next */
@GandalfModel
export class CreatePersonInsuranceRequest extends GandalfModelBase {

	@GandalfLabel('Intake Insurance')
	@GandalfProperty({ designType: Number })
	intakeInsuranceId!: number | null;

	@GandalfValidator({ sizeString: { message: 'Patient Benefits cannot be longer than 8000 characters', minLength: 0, maxLength: 8000 } })
	@GandalfProperty({ designType: String })
	patientBenefits!: string | null;

	@GandalfValidator({ notNull: { message: 'General Benefits is required' } })
	@GandalfProperty({ designType: CreatePatientGeneralBenefitsRequest, isRequired: true })
	patientGeneralBenefitsRequest!: CreatePatientGeneralBenefitsRequest;

	@GandalfValidator({ notNull: { message: 'Basic Information is required' } })
	@GandalfProperty({ designType: CreatePatientInsuranceBasicInformationRequest, isRequired: true })
	patientInsuranceBasicInformationRequest!: CreatePatientInsuranceBasicInformationRequest;

	@GandalfValidator({ notNull: { message: 'Material Benefits is required' } })
	@GandalfProperty({ designType: CreatePatientMaterialBenefitsRequest, isRequired: true })
	patientMaterialBenefitsRequest!: CreatePatientMaterialBenefitsRequest;

	@GandalfValidator({ notNull: { message: 'PersonId is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	personId!: number;

	@GandalfValidator({ sizeString: { message: 'Policy Benefits cannot be longer than 8000 characters', minLength: 0, maxLength: 8000 } })
	@GandalfProperty({ designType: String })
	policyHolderBenefits!: string | null;

}
